import { UIEvent, useState } from "react";

import throttle from "lodash.throttle";

import { Fade, Wrapper } from "./ScrollFade.styles";

type ScrollFadeProps = {
    children: React.ReactNode;
    height?: number;
    style?: React.CSSProperties;
    color?: string;
};

export const ScrollFade = ({
    children,
    height,
    style = {},
    color = "N0"
}: ScrollFadeProps) => {
    const [isNearTheEnd, setIsNearTheEnd] = useState(false);
    const fadeHeight = 40;

    const scrollHandler = throttle((e: UIEvent<HTMLDivElement>): void => {
        if (!e?.currentTarget) return;
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
        const scrollRemaining = scrollHeight - scrollTop - clientHeight;
        const nearTheEnd = scrollRemaining < fadeHeight;
        if (nearTheEnd !== isNearTheEnd) {
            setIsNearTheEnd(!isNearTheEnd);
        }
    }, 100);

    style.height = height;

    return (
        <Wrapper style={style}>
            <div
                onScroll={scrollHandler}
                style={{
                    height: height,
                    overflowY: height ? "auto" : undefined
                }}
            >
                {children}
                {height && (
                    <Fade
                        fadeHeight={fadeHeight}
                        fadeColor={color}
                        style={{ bottom: isNearTheEnd ? 0 - height : 0 }}
                    />
                )}
            </div>
        </Wrapper>
    );
};
